import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53737b7f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "border-b-2 border-black" }
const _hoisted_2 = { class: "teamName" }
const _hoisted_3 = ["src"]

import axios from 'axios'
import { onMounted, ref } from 'vue'
import { ITeam } from '../interfaces'


export default /*#__PURE__*/_defineComponent({
  props: {
    team: null
  },
  setup(__props: any) {

const props = __props as { team: ITeam }


const image = ref('')

onMounted(() =>
	axios
		.post('https://api-pingiskalk-wwr1.onrender.com/clubs/search', {
			search: props.team.team.replace(/\d+$/, '').trim(),
		})
		.then(({ data }) => data)
		.then((res) => {
			if (res instanceof Object && res.image) {
				return res.image
			} else return ''
		})
		.then((str) => str.replaceAll('{size}', '40'))
		.then((str) => (image.value = str))
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tr", _hoisted_1, [
    _createElementVNode("td", null, _toDisplayString(__props.team.placement) + ".", 1),
    _createElementVNode("td", _hoisted_2, [
      (image.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: image.value,
            class: "mr-2 w-4 h-4"
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("span", null, _toDisplayString(__props.team.team), 1)
    ]),
    _createElementVNode("td", null, _toDisplayString(__props.team.matches), 1),
    _createElementVNode("td", null, _toDisplayString(__props.team.wins), 1),
    _createElementVNode("td", null, _toDisplayString(__props.team.ties), 1),
    _createElementVNode("td", null, _toDisplayString(__props.team.loses), 1),
    _createElementVNode("td", null, _toDisplayString(__props.team.matchDiff), 1),
    _createElementVNode("td", null, _toDisplayString(__props.team.gameDiff), 1),
    _createElementVNode("td", null, _toDisplayString(__props.team.pointDiff), 1),
    _createElementVNode("td", null, _toDisplayString(__props.team.score), 1)
  ]))
}
}

})